import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const NSWRFSImage = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "nsw-rfs-logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 200, maxHeight: 252) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img
      fluid={data.placeholderImage.childImageSharp.fluid}
      alt="NSW-Rural-Fire-Service-logo"
    />
  )
}

export default NSWRFSImage
